import React from 'react'
import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { BASE_URL } from '../../Environment'
import { updateLocalStorage } from '../../stores/PublicDoctor/Auth'
import Loader from 'react-loader-spinner'

const RedirectPending = () => {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(location.search)
    const data = urlSearchParams.get('data') || '{}'
    const patient_id = urlSearchParams.get('patient_id') || ''
    if (data.length > 0) {
      const parsedData = JSON.parse(data)
      localStorage.setItem('doctor_auth_key', parsedData?.user?.id_token)
      localStorage.setItem('user_short_code', parsedData?.user?.user_short_code)
      localStorage.setItem('clinic_id', parsedData?.hospital_details?.id)
      localStorage.setItem('clinic_booking_patient_id', patient_id)
      localStorage.setItem('dr_token', parsedData?.dr_token)
      localStorage.setItem('pd_id', parsedData?.pd_id)
      updateLocalStorage(parsedData)
        .then(() => window.location.replace('/doctor/appointments'))
        .catch(console.error)
    } else alert('Bad Redirection')
  }, [location.search, history])

  return (
    <Loader
      type="ThreeDots"
      color="#114ebd"
      height={75}
      width={75}
      timeout={0}
      style={{ marginLeft: '50%' }}
    />
  )
}

export default RedirectPending
